import TagComponent from 'components/Tags';
import { capitalizeWords } from 'utils/helpers';
import { CollectionStatus } from '../types';
import testId from 'utils/testId';

interface CollectionStatusTagProps {
  status: CollectionStatus;
}

const statusColorMap: Record<CollectionStatus, Array<string>> = {
  LATE: ['#EF4B3F', '#FFEDEC'],
  LIVE: ['#FF9900', '#FFF6E9'],
  SETTLED: ['#318507', '#E8F0E4'],
};

const CollectionStatusTag = ({ status }: CollectionStatusTagProps) => {
  const labelColor = statusColorMap[status]?.[0];
  const bgColor = statusColorMap[status]?.[1];

  return (
    <TagComponent
      color={bgColor}
      style={{
        color: labelColor,
        padding: '3px 15px',
        fontWeight: 400,
        fontFamily: 'Poppins',
      }}
      label={capitalizeWords(status)}
      className={'tag'}
      data-test-id={
        testId.hotcashPage?.status?.[
          `tag-hotcash-${status?.toLowerCase()}` as keyof typeof testId.hotcashPage.status
        ]
      }
    />
  );
};

export default CollectionStatusTag;
